export default "__VITE_ASSET__6s2Fr39l__"